(() => {
  class ConfirmMailOrderCancellationController {
    constructor($rootScope, $scope, $timeout, $interval, Users, toastr, $state, ngDialog) {
      'ngInject';

      Object.assign(this, {
        $scope,
        $rootScope,
        $timeout,
        $interval,
        Users,
        toastr,
        $state,
        ngDialog,
        cancelReasons: [],
        selectedReason: [],
        cancel_reason_code: null,
        saveEnabled: false
      });
      $scope.$on('ngDialog.opened', function (e, $dialog) {
        $(".ngdialog-theme-default.ngdialog").children(".ngdialog-content").draggable({
          handle: ".mailorder-cancellation-popup-handler"
        });
      });
      this.getCancelReasons(); // Default Value for Radio Option

      this.status = 'cancelled';
      this.options = [{
        id: '1',
        name: 'User cancelled',
        value: 'cancelled'
      }];
      this.$timeout(function () {
        $("button.md-datepicker-button").css("margin-left", "34px");
        $("input.md-datepicker-input").css("background-color", "#EEEFF2");
      }, 100);
    }

    getCancelReasons() {
      this.Users.getCancelReasons().then(({
        data
      }) => {
        this.cancelReasons = data;
      });
    }

    setCancelReason() {
      this.cancel_reason_code = this.selectedReason[0].code;
    } // close() {
    //   this.$scope.closeThisDialog(null);
    // }


    save() {
      var response = {
        status: this.status,
        cancel_reason_code: this.cancel_reason_code
      };
      this.$scope.closeThisDialog(response);
    }

  }

  ConfirmMailOrderCancellationController.$inject = ["$rootScope", "$scope", "$timeout", "$interval", "Users", "toastr", "$state", "ngDialog"];
  angular.module('pims').controller('ConfirmMailOrderCancellationController', ConfirmMailOrderCancellationController);
})();